import React from "react";
import ReactApexChart from "react-apexcharts";
import { Row, Col, Card, CardBody } from "reactstrap";

const EnptKpiCharts = ({ kpis }) => {
  // Reverse the array so charts display chronologically (oldest on left, newest on right)
  const data = Array.isArray(kpis) ? [...kpis].reverse() : kpis ? [kpis] : [];

  // Data extraction
  const categories = data.map(kpi => kpi.test_date || '');

  // 1. Delivery Ratios Chart
  const deliveryRatiosSeries = [
    {
      name: 'Message delivery ratio (%)',
      data: data.map(kpi => (kpi.message_delivery_ratio || 0) * 100)
    },
    {
      name: 'Enterprise delivery ratio (%)',
      data: data.map(kpi => (kpi.enterprise_delivery_ratio || 0) * 100)
    }
  ];

  const deliveryRatiosOptions = {
    chart: {
      type: 'line',
      height: 350,
      toolbar: { show: false }
    },
    colors: ['#007bff', '#dc3545'], // Blue, Red
    stroke: {
      curve: 'straight',
      width: 3
    },
    title: {
      text: 'Delivery Ratios',
      align: 'center',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#495057'
      }
    },
    markers: {
      size: 4
    },
    xaxis: {
      categories: categories
    },
    yaxis: {
      labels: {
        formatter: function(val) {
          return val.toFixed(1) + "%";
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function(val) {
        return val.toFixed(1) + "%";
      },
      offsetY: -5
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center'
    }
  };

  // 2. SMS Ratios Chart
  const smsRatiosSeries = [
    {
      name: 'SMS ratio (%)',
      data: data.map(kpi => (kpi.sms_ratio || 0) * 100)
    },
    {
      name: 'Other channel ratio (%)',
      data: data.map(kpi => (kpi.other_channel_ratio || 0) * 100)
    },
    {
      name: 'SMS Bypass ratio (%)',
      data: data.map(kpi => (kpi.bypass_ratio || 0) * 100)
    }
  ];

  const smsRatiosOptions = {
    chart: {
      type: 'line',
      height: 350,
      toolbar: { show: false }
    },
    colors: ['#007bff', '#007bff', '#dc3545'], // Solid Blue, Dashed Blue, Red
    stroke: {
      curve: 'straight',
      width: [3, 3, 3],
      dashArray: [0, 5, 0] // 0 = solid, 5 = dashed, 0 = solid
    },
    title: {
      text: 'SMS Ratios',
      align: 'center',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#495057'
      }
    },
    markers: {
      size: 4
    },
    xaxis: {
      categories: categories
    },
    yaxis: {
      labels: {
        formatter: function(val) {
          return val.toFixed(1) + "%";
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function(val) {
        return val.toFixed(1) + "%";
      },
      offsetY: -5
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center'
    }
  };

  return (
    <div className="pt-4">
      <Row>
        <Col lg={12}>
          <Card className="kpichart-style">
            <CardBody>
              {data.length > 0 ? (
                <ReactApexChart options={deliveryRatiosOptions} series={deliveryRatiosSeries} type="line" height={350} />
              ) : (
                <div className="text-center py-4">No data available</div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <Card className="kpichart-style">
            <CardBody>
              {data.length > 0 ? (
                <ReactApexChart options={smsRatiosOptions} series={smsRatiosSeries} type="line" height={350} />
              ) : (
                <div className="text-center py-4">No data available</div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default EnptKpiCharts;
